module.exports = __webpack_public_path__ + "static/sanbikinokobuta_w264xh200-6682e4a59adee8f77dc55dfff4c5cd68.png";